<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.85" y="1.4418" width="18.3" height="19.1159" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
<line x1="1.84033" y1="9.22627" x2="20.9104" y2="9.22627" stroke="currentColor" stroke-width="1.4"/>
<line x1="4.77747" y1="12.8391" x2="11.5008" y2="12.8391" stroke="currentColor" stroke-width="1.4"/>
<line x1="4.77747" y1="16.3811" x2="9.92517" y2="16.3811" stroke="currentColor" stroke-width="1.4"/>
<path d="M5.8269 3.89355L5.8269 6.73503" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
</svg>
